import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import * as types from "misc/types";
import { getText, trackGA } from "misc/helpers";

const linkToDigitalMailboxes = getText(
    "linkToDigitalMailbox",
    "https://www.digg.se/digital-post/privatperson"
);
class RegisterInfo extends Component {
    render() {
        const linkToDigitalMailboxes = getText(
            "linkToDigitalMailbox",
            "https://www.digg.se/digital-post/privatperson"
        );

        return (
            <div className="main-content">
                <Link to="/login">
                    <div className="agreement-back-link">
                        <img
                            src="assets/images/agreement/back_arrow.svg"
                            alt=""
                        />{" "}
                        <span>{getText("_1_3_TextBack", "Tillbaka")}</span>
                    </div>
                </Link>
                <div className="complement-content register-info">
                    <img
                        className="complement-logo"
                        src="assets/images/verify/ico_dm_v.svg"
                        alt=""
                    />
                    <h1>{getText("titleNoRegistration", "Hej!")}</h1>
                    <p>
                        {getText(
                            "descriptionNoRegistrationPart1",
                            "Kul att du är intresserad av att skapa en digital brevlåda, men tyvärr så kommer Digimail att stänga ner sin service inom kort. Vi rekommenderar att ni surfar in på "
                        )}
                        <a href={linkToDigitalMailboxes}>
                            {linkToDigitalMailboxes}
                        </a>
                        {getText(
                            "descriptionNoRegistrationPart2",
                            " och finner en digital brevlåda som passar erat behov."
                        )}
                    </p>
                </div>

                <img
                    className="logo-bottom-left"
                    src="assets/images/digimail_logo_yellow.svg"
                    alt=""
                />
            </div>
        );
    }

    componentDidMount() {
        // Logout eventual session
        // const { dispatch } = this.props;
        // dispatch({ type: types.SAGA_LOGOUT.REQUEST });

        trackGA("2.1 Registrering info");
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(RegisterInfo);



// WEBPACK FOOTER //
// ./src/components/views/RegisterInfo.js